export default "__VITE_ASSET__BoZglutv__"